var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgNoDataHelper = function SvgNoDataHelper(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "80px",
    height: "80px",
    viewBox: "0 0 80 80",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "path-1",
    x: 0,
    y: 0,
    width: 40,
    height: 40
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "5.-Health-Screening",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "5.1.0-Health-screening-/-Upcoming---empty-state",
    transform: "translate(-809.000000, -415.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "04.Organisms/07.Card/04.Confirmation/Empty-state",
    transform: "translate(697.000000, 415.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(112.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#F1F1F1",
    x: 0,
    y: 0,
    width: 80,
    height: 80,
    rx: 40
  }), /*#__PURE__*/React.createElement("g", {
    id: "Icon",
    transform: "translate(20.000000, 20.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Mask"
  }), /*#__PURE__*/React.createElement("g", {
    id: "clipboard",
    mask: "url(#mask-2)",
    fill: "#999999",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(8.333333, 5.000000)",
    id: "Shape"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18,2 L17.286875,2 C17.0813526,1.99979289 16.8968906,1.873843 16.821875,1.6825 C16.4286417,0.669192564 15.4538079,0.00110384864 14.366875,0 L7.633125,0 C6.54619207,0.00110384864 5.57135832,0.669192564 5.178125,1.6825 C5.1031094,1.873843 4.91864736,1.99979289 4.713125,2 L4,2 C1.790861,2 0,3.790861 0,6 L0,26 C0,28.209139 1.790861,30 4,30 L18,30 C20.209139,30 22,28.209139 22,26 L22,6 C22,3.790861 20.209139,2 18,2 Z M14.991875,6 L7.008125,6 C6.45584025,6 6.008125,5.55228475 6.008125,5 C6.008125,4.44771525 6.45584025,4 7.008125,4 L14.991875,4 C15.5441597,4 15.991875,4.44771525 15.991875,5 C15.991875,5.55228475 15.5441597,6 14.991875,6 Z"
  }))))))))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgNoDataHelper, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/no-data-helper.6eeff0e4.svg";
export { ForwardRef as ReactComponent };